import { createSlice } from '@reduxjs/toolkit';
import { ISubscriptionState } from './types';
import { 
  fetchSubscriptionPlans, 
  fetchSubscriptionCounts, 
  fetchSubscriptionPlanDetail,
  fetchSubscribedOrganizations,
  toggleSubscriptionPlanStatus
} from './actions';

const initialState: ISubscriptionState = {
  plans: {
    loading: false,
    data: [],
    count: 0,
    error: null,
  },
  currentPlan: {
    loading: false,
    data: null,
    error: null,
  },
  subscribedOrgs: {
    loading: false,
    data: [],
    count: 0,
    error: null,
  },
  counts: {
    loading: false,
    data: {
      total_plans: 0,
      active_plans: 0,
      active_subscriptions: 0,
    },
    error: null,
  },
};

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    clearCurrentPlan: (state) => {
      state.currentPlan.data = null;
      state.currentPlan.error = null;
      state.currentPlan.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Plans
      .addCase(fetchSubscriptionPlans.pending, (state) => {
        state.plans.loading = true;
        state.plans.error = null;
      })
      .addCase(fetchSubscriptionPlans.fulfilled, (state, action) => {
        state.plans.loading = false;
        state.plans.data = action.payload.results;
        state.plans.count = action.payload.count;
      })
      .addCase(fetchSubscriptionPlans.rejected, (state, action) => {
        state.plans.loading = false;
        state.plans.error = action.payload as string;
      })
      // Fetch Plan Detail
      .addCase(fetchSubscriptionPlanDetail.pending, (state) => {
        state.currentPlan.loading = true;
        state.currentPlan.error = null;
        state.currentPlan.data = null;
      })
      .addCase(fetchSubscriptionPlanDetail.fulfilled, (state, action) => {
        state.currentPlan.loading = false;
        state.currentPlan.data = action.payload;
      })
      .addCase(fetchSubscriptionPlanDetail.rejected, (state, action) => {
        state.currentPlan.loading = false;
        state.currentPlan.error = action.payload as string;
      })
      // Fetch Subscribed Organizations
      .addCase(fetchSubscribedOrganizations.pending, (state) => {
        state.subscribedOrgs.loading = true;
        state.subscribedOrgs.error = null;
      })
      .addCase(fetchSubscribedOrganizations.fulfilled, (state, action) => {
        state.subscribedOrgs.loading = false;
        state.subscribedOrgs.data = action.payload.results;
        state.subscribedOrgs.count = action.payload.count;
      })
      .addCase(fetchSubscribedOrganizations.rejected, (state, action) => {
        state.subscribedOrgs.loading = false;
        state.subscribedOrgs.error = action.payload as string;
      })
      // Fetch Counts
      .addCase(fetchSubscriptionCounts.pending, (state) => {
        state.counts.loading = true;
        state.counts.error = null;
      })
      .addCase(fetchSubscriptionCounts.fulfilled, (state, action) => {
        state.counts.loading = false;
        state.counts.data = action.payload;
      })
      .addCase(fetchSubscriptionCounts.rejected, (state, action) => {
        state.counts.loading = false;
        state.counts.error = action.payload as string;
      })
      // Toggle Plan Status
      .addCase(toggleSubscriptionPlanStatus.fulfilled, (state, action) => {
        if (state.currentPlan.data && String(state.currentPlan.data.plan_id) === String(action.payload.planId)) {
          state.currentPlan.data.is_active = action.payload.isActive;
        }
      });
  },
});

export const { clearCurrentPlan } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
